import { render, staticRenderFns } from "./review.vue?vue&type=template&id=3e75beb9&scoped=true"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"
import style0 from "./review.vue?vue&type=style&index=0&id=3e75beb9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e75beb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e75beb9')) {
      api.createRecord('3e75beb9', component.options)
    } else {
      api.reload('3e75beb9', component.options)
    }
    module.hot.accept("./review.vue?vue&type=template&id=3e75beb9&scoped=true", function () {
      api.rerender('3e75beb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goods/review.vue"
export default component.exports